import { css } from 'styled-components';

export const ProductTourAnimationCss = css`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Fade in tooltip on appearance */
  .__floater {
    animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.15s both;
  }

  /* Fade in spotlight on appearance */
  .react-joyride__spotlight {
    animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) 0.15s both;
  }
`;
